
import {defineComponent} from 'vue';
import Overlay from '@ohrm/oxd/core/components/Dialog/Overlay.vue';
import CloseButton from '@ohrm/oxd/core/components/Dialog/CloseButton.vue';
import Sheet from '@ohrm/oxd/core/components/Sheet/Sheet.vue';

// Containers
import DefaultContainer from '@ohrm/oxd/core/components/Dialog/Container/Default.vue';

export default defineComponent({
  name: 'oxd-dialog',
  inheritAttrs: false,

  components: {
    'oxd-overlay': Overlay,
    'oxd-dialog-close-button': CloseButton,
    'oxd-sheet': Sheet,

    // Containers
    'oxd-dialog-container-default': DefaultContainer,
  },

  emits: ['update:show'],

  props: {
    shadow: {
      type: Boolean,
      default: true,
    },
    withClose: {
      type: Boolean,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    dialogContainer: {
      type: String,
      default: 'oxd-dialog-container-default',
    },
    withTransition: {
      type: Boolean,
      default: true,
    },
    gutters: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-dialog-sheet': true,
        'oxd-dialog-sheet--shadow': this.shadow,
        'oxd-dialog-sheet--gutters': this.gutters,
      };
    },
    computedTransition(): string {
      return this.withTransition ? 'fade' : '';
    },
  },

  methods: {
    onClose() {
      this.$emit('update:show', false);
    },
    onClickOverlay() {
      if (!this.persistent) {
        this.$emit('update:show', false);
      }
    },
    onClickSheet(e: Event) {
      e.stopPropagation();
    },
  },
});
